const PageHeader = () => {
    return (
        <main className="main-content main-content-bg mt-0">
            <div 
                className="page-header align-items-start min-height-300 m-3 border-radius-xl bg-gray-200 desktop-bg-contain"
                style={{backgroundImage: `url('/assets/img/252656-P4JXW1-854.png')`}}
            >
                {/* <span className={`mask bg-gradient-${theme.main} opacity-4`}></span> */}
            </div>
        </main>
    );
}

export default PageHeader;